export default "__VITE_ASSET__wM2aMP$3__"